import { render, staticRenderFns } from "./ChartCanvasViewer.vue?vue&type=template&id=1af80fa7"
import script from "./ChartCanvasViewer.vue?vue&type=script&lang=js"
export * from "./ChartCanvasViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports